<template>
  <div v-if="!loading">
    <!-- <a-affix> -->
      <a-page-header
        style="border-bottom: 1px solid rgb(235, 237, 240); background: #fff"
        class="mb-5 px-0"
        title="Product Detail"
        @back="() => $router.go(-1)"
      >
      </a-page-header>
    <!-- </a-affix> -->
    <div class="card mt-3" style="padding: 2rem">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <div>
                <inner-image-zoom
                  :src="`${!!showImage ? showImage.url : product.all_images[0].url}?tr=w-800,h-800,cm-pad_resize,bg-FFFFFF`"
                  style="max-width: 100%"
                />
              </div>
              <div
                class="mt-3"
                v-if="!!product.all_images && !!product.all_images.length"
              >
                <a
                  v-for="(image, index) in product.all_images"
                  :key="index"
                  class="pr-4"
                  @click="setShowImage(image)"
                >
                  <img
                    class="img-thumbnail mb-2"
                    :src="`${image.url}`"
                    style="max-width: 20%"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-6">
              <h2 class="mt-2">
                {{ selectedItem.product_name }}
              </h2>
              <div class="price">
                <!-- <span
                  v-if="discount"
                  class="original-price mr-1 text-muted"
                >
                  <s>
                    {{ price.price_msrp | currency }}
                  </s>
                </span>
                <span
                  style="font-size: 24px; font-weight: bold;"
                >
                  {{ price.selling_price | currency }}
                </span> -->
              </div>
              <!-- <div class="description pt-4 pb-3">
                <dl class="row mb-0">
                  <dt class="col-4 col-lg-2 col-xl-2 font-weight-lighter text-muted">
                    SKU
                  </dt>
                  <dd class="col-6 col-lg-10 col-xl-10">
                    {{ selectedItem.sku }}
                  </dd>
                  <dt class="col-4 col-lg-2 col-xl-2 font-weight-lighter text-muted">
                    Weight
                  </dt>
                  <dd class="col-6 col-lg-10 col-xl-10">
                    {{ selectedItem.product_weight }} gram
                  </dd>
                  <dt class="col-4 col-lg-2 col-xl-2 font-weight-lighter text-muted">
                    Availability
                  </dt>
                  <dd class="col-6 col-lg-10 col-xl-10 availability">
                    <div class="p-0 m-0 w-100 d-block">
                      <span class="in-stock" v-if="selectedItem.availability > 0"> In Stock </span>
                      <span class="pre-order" v-if="selectedItem.availability <= 0 && !!selectedItem.preorder"> Pre Order </span>
                      <span class="out-of-stock" v-else-if="selectedItem.availability <= 0 && !selectedItem.preorder"> Out of Stock </span>
                    </div>
                  </dd>
                </dl>
              </div> -->
              <div class="description pt-4 pb-3" v-if="product.attributes.length">
                <div class="my-3" v-for="(item, index) in product.attributes" :key="index">
                  <div class="text-muted">{{ item.name }}</div>
                  <div v-if="item.type !== 'text' && item.type !== 'longtext'">
                    <div v-if="item.type === 'currency'"> {{ Number(item.text) | currency }} </div>
                    <div v-else-if="item.type === 'date'"> {{ $moment(Number(item.text) * 1000).format('YYYY - MMMM - DD') }} </div>
                    <div v-else> {{ item.text }} </div>
                  </div>
                </div>
              </div>
              <div
                class="options"
                v-for="(option, index) in options"
                :key="index"
              >
                <div
                  v-if="!!option.variants.length"
                  class="form-group mt-4"
                  :key="option.key"
                >
                  <label class="control-label mb-0">
                    {{option.label}}
                  </label>
                  <div>
                    <div
                      v-for="value in option.variants"
                      :key="value"
                      class="radio-type-button radio mb-1"
                    >
                      <label class="mb-0">
                        <input
                          type="radio"
                          :name="option.key"
                          :checked="variant[option.key] === value"
                          :value="value"
                          @change="(e) => changeVariant({...variant, [option.key]: e.currentTarget.value})"
                        />
                        <span
                          :class="{ active: variant[option.key] === value }"
                        >
                          {{ value }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="description font-weight-normal text-justify">
                <h3> Description </h3>
                <div v-html="description.longDesc"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InnerImageZoom from 'vue-inner-image-zoom'

export default {
  components: {
    InnerImageZoom,
  },
  data: function () {
    return {
      showImage: null,
      title: 'Product Detail',
    }
  },
  metaInfo () {
    return {
      title: this.title,
    }
  },
  computed: {
    ...mapState('product', {
      product: state => state.productDetail,
      colorOptions: state => state.colorOptions,
      sizeOptions: state => state.sizeOptions,
      flavorOptions: state => state.flavorOptions,
      defaultOptions: state => state.defaultOptions,
      loading: state => state.loading,
    }),
    variant () {
      return this.defaultOptions
    },
    selectedItem () {
      const selected = this.product.catalog_list.find((item) => {
        const [color, size, flavor] = item.option
        const colorOpt = color || null
        const sizeOpt = size || null
        const flavorOpt = flavor || null
        return (
          (colorOpt === this.variant.color) &&
          (sizeOpt === this.variant.size) &&
          (flavorOpt === this.variant.flavor)
        )
      }) || {}
      return selected
    },
    price () {
      if (!this.product.price_list) return
      const price = this.product.price_list.find(
        (item) => item.catalog_id === this.selectedItem?.catalog_id,
      ) || {}
      return price
    },
    discount () {
      const discount =
      this.price.selling_price && this.price.selling_price < this.price.price_msrp
        ? this.price.price_msrp - this.price.selling_price
        : 0
      return discount
    },
    options () {
      return [
        {
          key: 'color',
          label: 'Color',
          variants: this.colorOptions,
        },
        {
          key: 'size',
          label: 'Size',
          variants: this.sizeOptions,
        },
        {
          key: 'flavor',
          label: 'Flavor',
          variants: this.flavorOptions,
        },
      ]
    },
    description () {
      return this.product.description.length ? this.product.description[0] : {}
    },
  },
  beforeCreate () {
    this.$store.dispatch('product/GETPRODUCTDETAIL', this.$route.params.id)
  },
  methods: {
    changeVariant (payload) {
      this.$store.commit('product/SET_DEFAULT_OPTIONS', payload)
    },
    setShowImage (value) {
      this.showImage = value
    },
  },
  watch: {
    product: {
      deep: true,
      handler: function (value) {
        if (value) {
          this.title = `Product - ${value.title}`
        }
      },
    },
  },
}
</script>

<style lang="sass">
.price
  line-height: 1.2
  color: black
  font-size: 1.2rem
  font-weight: 500

.original-price
  font-size: .65rem
  color: gray
  font-weight: 200
  height: 15px

  span
    transform: translateY(-10px)
    padding: .15rem .35rem
    font-size: .6rem
    margin-left: 5px
    margin-right: -10px
    background: rgba(220, 53, 69, 0.15)
    color: #dc3545
    font-weight: 500
    text-transform: uppercase

.availability
  .out-of-stock
    color: var(--danger)

  .in-stock
    color: var(--info)

  .pre-order
    color: var(--orange)
</style>

<style lang="scss">
.description {
  padding: 30px 0px 30px 0px;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);
  line-height: 23px;
  font-weight: bold;

  span {
    display: inline-block;
    width: 140px;
    max-width: 50%;
    padding-right: 20px;
    font-weight: normal;
  }
}
.price {
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);
  padding-bottom: 23px;
  padding-top: 5px;
}
.options {
  padding-bottom: 0px;

  h2 {
    padding: 0px;
    margin: 30px 0px 0px 0px;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 400;
  }

  > div > label {
    text-transform: uppercase;
    padding-bottom: 5px;
    font-size: 13px;
  }

  .form-group {
    margin: 22px 0px 0px 0px;
  }

  .error {
    margin: 0px;
  }
}
.radio-type-button {
  display: inline-block;
  vertical-align: top;
  width: auto;
  margin: 5px 7px 5px 0px;
  padding: 0px;

  input {
    visibility: hidden;
    position: absolute;
  }

  span {
    background: #efefef;
    height: 25px;
    min-width: 25px;
    border: 1px solid #fff;
    display: block;
    text-align: center;
    padding: 1px 5px;
    font-weight: bold;
    color: #636363;
    line-height: 1.5em;

    &:hover {
      border: 1px solid #000;
    }

    &.active {
      background: #000;
      color: #fff;
    }
  }
}
</style>
